import React, {
  useState,
  useImperativeHandle,
  ForwardRefRenderFunction,
  useRef,
  useEffect,
} from 'react';
import { Modal, Button } from 'antd';
import { DayJs } from '../../common/Utils';
import GeneralLedgerList, { GeneralLedgerListType } from './GeneralLedgerList';
import { useBusinessContext } from '../../context/BusinessContext';

export type GeneralLedgerDialogInstance = {
  open: (account: string, from?: DayJs.Dayjs, to?: DayJs.Dayjs) => void;
};

const GeneralLedgerDialog: ForwardRefRenderFunction<
  GeneralLedgerDialogInstance,
  {}
> = (_, ref) => {
  const business = useBusinessContext();

  const listRef = useRef<GeneralLedgerListType>(null);
  const [visible, setVisible] = useState<boolean>(false);
  const [dialogState, setDialogState] = useState<{
    account: string;
    from?: DayJs.Dayjs;
    to?: DayJs.Dayjs;
  } | null>(null);

  const accountName = business.accounts[dialogState?.account ?? '']?.name;

  useImperativeHandle(ref, () => ({
    open: (account: string, from?: DayJs.Dayjs, to?: DayJs.Dayjs) => {
      setDialogState({
        account,
        from,
        to,
      });
      setVisible(true);
    },
  }));

  useEffect(() => {
    if (visible && dialogState && listRef.current) {
      listRef.current?.update(
        dialogState?.account ?? '',
        undefined,
        dialogState?.from,
        dialogState?.to,
      );
    }
  }, [visible, listRef, dialogState]);

  return (
    <Modal
      title={`Transactions for [ ${accountName} ]`}
      width={'80%'}
      style={{
        maxWidth: '90%',
        maxHeight: '80%',
      }}
      open={visible}
      onCancel={() => setVisible(false)}
      footer={() => {
        return (
          <div
            style={{
              display: 'flex',
              justifyContent: 'right',
              marginTop: 20,
            }}
          >
            <Button type="primary" onClick={() => setVisible(false)}>
              Close
            </Button>
          </div>
        );
      }}
      centered
    >
      {dialogState && (
        <div
          style={{
            paddingTop: 20,
          }}
        >
          <GeneralLedgerList ref={listRef} showAccountHeader={false} />
        </div>
      )}
    </Modal>
  );
};

export const useGeneralLedgerDialog = () =>
  useRef<GeneralLedgerDialogInstance>(null);

export default React.forwardRef<GeneralLedgerDialogInstance, {}>(
  GeneralLedgerDialog,
);
